// Theme: vaporwave
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'vaporwave',
  name: 'VAPORWAVE',
  tagline: 'VAPORWAVE',
  description: 'Estetica vaporwave com lilas pastel e grid retro-futurista.',
  category: 'retro-memory',
  tier: 'epic',
  basePrice: 2000,
  swatches: ['#0F0820', '#1A1035', '#E879F9', '#F3E8FF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-vaporwave'
  },
  colorVars: {
    '--accent': '#E879F9',
    '--accent-foreground': '#0F0820',
    '--background': '#0F0820',
    '--border': '#5A2A7A',
    '--card': '#1A1035',
    '--card-border-active': 'rgba(232, 121, 249, 0.55)',
    '--card-completed': '#170F2E',
    '--card-foreground': '#F3E8FF',
    '--card-glow': 'rgba(232, 121, 249, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#F3E8FF',
    '--hold-fill': '#E879F9',
    '--input': '#5A2A7A',
    '--modal-bg': '#0F0820',
    '--modal-border': '#5A2A7A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#5A2A7A',
    '--muted-foreground': '#F3E8FF',
    '--nav-active': '#E879F9',
    '--nav-bg': '#1A1035',
    '--popover': '#1A1035',
    '--popover-foreground': '#F3E8FF',
    '--primary': '#E879F9',
    '--primary-foreground': '#0F0820',
    '--ring': '#E879F9',
    '--secondary': '#5A2A7A',
    '--secondary-foreground': '#F3E8FF',
    '--streak': '#E879F9',
    '--success': '#22c55e',
    '--success-foreground': '#0F0820',
    '--xp': '#E879F9',
    '--xp-bg': '#1A1035'
  },
  resolvedVars: {
    '--accent': '#E879F9',
    '--accent-foreground': '#0F0820',
    '--accent-foreground-hsl': '258 60% 8%',
    '--accent-foreground-oklch': 'from #0F0820 l c h',
    '--accent-hsl': '292 91% 73%',
    '--accent-oklch': 'from #E879F9 l c h',
    '--background': '#0F0820',
    '--background-hsl': '258 60% 8%',
    '--background-oklch': 'from #0F0820 l c h',
    '--border': '#5A2A7A',
    '--border-hsl': '276 49% 32%',
    '--border-oklch': 'from #5A2A7A l c h',
    '--border-w': '1px',
    '--card': '#1A1035',
    '--card-border-active': 'rgba(232, 121, 249, 0.55)',
    '--card-completed': '#170F2E',
    '--card-completed-hsl': '255 51% 12%',
    '--card-completed-oklch': 'from #170F2E l c h',
    '--card-foreground': '#F3E8FF',
    '--card-foreground-hsl': '269 100% 95%',
    '--card-foreground-oklch': 'from #F3E8FF l c h',
    '--card-glow': 'rgba(232, 121, 249, 0.10)',
    '--card-hsl': '256 54% 14%',
    '--card-oklch': 'from #1A1035 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F3E8FF',
    '--foreground-hsl': '269 100% 95%',
    '--foreground-oklch': 'from #F3E8FF l c h',
    '--hold-fill': '#E879F9',
    '--hold-fill-hsl': '292 91% 73%',
    '--hold-fill-oklch': 'from #E879F9 l c h',
    '--input': '#5A2A7A',
    '--input-hsl': '276 49% 32%',
    '--input-oklch': 'from #5A2A7A l c h',
    '--modal-bg': '#0F0820',
    '--modal-bg-hsl': '258 60% 8%',
    '--modal-bg-oklch': 'from #0F0820 l c h',
    '--modal-border': '#5A2A7A',
    '--modal-border-hsl': '276 49% 32%',
    '--modal-border-oklch': 'from #5A2A7A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#5A2A7A',
    '--muted-foreground': '#F3E8FF',
    '--muted-foreground-hsl': '269 100% 95%',
    '--muted-foreground-oklch': 'from #F3E8FF l c h',
    '--muted-hsl': '276 49% 32%',
    '--muted-oklch': 'from #5A2A7A l c h',
    '--nav-active': '#E879F9',
    '--nav-active-hsl': '292 91% 73%',
    '--nav-active-oklch': 'from #E879F9 l c h',
    '--nav-bg': '#1A1035',
    '--nav-bg-hsl': '256 54% 14%',
    '--nav-bg-oklch': 'from #1A1035 l c h',
    '--popover': '#1A1035',
    '--popover-foreground': '#F3E8FF',
    '--popover-foreground-hsl': '269 100% 95%',
    '--popover-foreground-oklch': 'from #F3E8FF l c h',
    '--popover-hsl': '256 54% 14%',
    '--popover-oklch': 'from #1A1035 l c h',
    '--primary': '#E879F9',
    '--primary-foreground': '#0F0820',
    '--primary-foreground-hsl': '258 60% 8%',
    '--primary-foreground-oklch': 'from #0F0820 l c h',
    '--primary-hsl': '292 91% 73%',
    '--primary-oklch': 'from #E879F9 l c h',
    '--radius': '12px',
    '--ring': '#E879F9',
    '--ring-hsl': '292 91% 73%',
    '--ring-oklch': 'from #E879F9 l c h',
    '--secondary': '#5A2A7A',
    '--secondary-foreground': '#F3E8FF',
    '--secondary-foreground-hsl': '269 100% 95%',
    '--secondary-foreground-oklch': 'from #F3E8FF l c h',
    '--secondary-hsl': '276 49% 32%',
    '--secondary-oklch': 'from #5A2A7A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#E879F9',
    '--streak-hsl': '292 91% 73%',
    '--streak-oklch': 'from #E879F9 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0F0820',
    '--success-foreground-hsl': '258 60% 8%',
    '--success-foreground-oklch': 'from #0F0820 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(292 91% 73% / 0.15)',
    '--xp': '#E879F9',
    '--xp-bg': '#1A1035',
    '--xp-bg-hsl': '256 54% 14%',
    '--xp-bg-oklch': 'from #1A1035 l c h',
    '--xp-hsl': '292 91% 73%',
    '--xp-oklch': 'from #E879F9 l c h'
  }
}
